export default "__VITE_ASSET__BMF6KfuV__"